export default "__VITE_ASSET__CkCeVht0__"